import { useState } from 'react'
import { useRouter } from 'next/router'
import useSWRMutation from 'swr/mutation'
import internalApiQueryWrapper from '../../network/internalApiQueryWrapper'
import style from '../../styles/components/need2know/need2know'

const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const SignUp = () => {
  const router = useRouter()
  const [emailAddress, setEmailAddress] = useState('')
  const [helperText, setHelperText] = useState('')
  const [isSubscribed, setIsSubscribed] = useState(router.asPath.includes('success'))

  const { trigger, isMutating } = useSWRMutation(
    () => ({
      url: `/api/subscribe`,
      args: {
        email: emailAddress,
        lists: JSON.stringify({ need2know: 1 }),
        vars: JSON.stringify({ source: 'n2k_page' })
      }
    }),
    internalApiQueryWrapper
  )

  const subscribe = async () => {
    const response = await trigger()
    if (response.error) {
      setHelperText('Something went wrong. Please check email address or try again later.')
    } else if (response.ok) {
      setIsSubscribed(response.ok)
    }
  }

  const onClick = async () => {
    if (EMAIL_VALIDATION_REGEX.test(emailAddress)) {
      await subscribe()
    } else {
      setHelperText('Oops, that email address is invalid!')
    }
  }

  return (
    <>
      <div className='signup-container'>
        {!isSubscribed ? (
          <div className='content'>
            <div className='signup-title'>Sign up for the Need2Know Newsletter</div>
            <div className='input-container'>
              <input placeholder='email address' value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} />
              <button className='submit-button' disabled={isMutating} onClick={onClick}>
                Sign Up
              </button>
            </div>
            {helperText && <div className='helper-text'>{helperText}</div>}
          </div>
        ) : (
          <div className='success-message'>All set, thanks for signing up!</div>
        )}
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default SignUp
